export default __webpack_public_path__ + "static/media/reports.f50b6f92.png";